// extracted by mini-css-extract-plugin
export default {"containerReviews":"Comment_containerReviews__Yur6K","container":"Comment_container__TAZyb","title":"Comment_title__ylZSu","postBoton":"Comment_postBoton__oo997"};